import { defineStore } from 'pinia'

type ForgetPasswordSentCodeResponse = {
  sent: boolean
  expiresAfter: number
  sentTo: string
  name: string
  username: string
  avatar: string
}

export const useUserInfoStore = defineStore('userInfo', {
  persist: true,
  state: () => ({ user: {} as ForgetPasswordSentCodeResponse }),
  getters: {
    getUserInfo: (state) => state.user
  },
  actions: {
    setUserInfo(user: ForgetPasswordSentCodeResponse) {
      this.user = user
    }
  }
})
